export class UserPoints {
    userId:number;
    points:number
}